import { Box, Stack } from '@mui/material';

const LinkedInFeed = () => {
  // LinkedIn embed URLs
  const linkedInPosts = [
    'https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7346430909232918529',
    'https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7345556052039327745',
    'https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7344308439734456323'
  ];

  return (
    <Box
      sx={{
        minHeight: '100vh', // Minimum viewport height, allows expansion
        bgcolor: '#f3f2ef', // LinkedIn's background color
        padding: 2,
      }}
    >
      <Stack spacing={3}>
        {linkedInPosts.map((postUrl, index) => (
          <Box 
            key={index}
            sx={{
              width: '100%',
              // maxWidth: 552, // LinkedIn's standard post width
              mx: 'auto', // Center the posts
              bgcolor: 'white',
              borderRadius: 2,
              overflow: 'hidden',
              boxShadow: '0 0 0 1px rgba(0,0,0,0.15)',
            }}
          >
            <iframe
              src={postUrl}
              width="100%"
              height="600"
              frameBorder="0"
              allowTransparency="true"
              title={`LinkedIn Post ${index + 1}`}
              style={{
                border: 'none',
                overflow: 'hidden',
              }}
            />
          </Box>
        ))}
      </Stack>
    </Box>
  );
};
export default LinkedInFeed;